export default __webpack_public_path__ + "static/media/memoji.6c7a6a87.png";